export const testimonials = [
  {
    id: 1,
    quote:
      "Stephanie was very patient with our baby and with us. She has baby outfits available and let us bring our own. We did half the pictures one day and came back the next day because our baby was fussy. She took her time to get the best shot with every picture. Highly recommend! Amazing quality.",
    author: "M. Gutierrez",
    service: "Newborn Photography",
    image: "https://images-pw.pixieset.com/site/BAJyQr/DDl4Qv/004-20241021-ea579869-1500.jpg",
  },
  {
    id: 2,
    quote:
      "I would give 10 stars if I could!! Stephanie and the whole team were amazing! The angles, the guidance with the poses, the expertise she had with knowing what back-grounds would be complimentary were on point. She has a calming way of guiding you and then gracefully capturing the moment. I will be using Precious Keepsakes Photography for all my photography needs. She nailed it 100%. So grateful we went through them for our wedding photography! Now we can look back at these gorgeous photos for a lifetime!!",
    author: "Lauren & Josh",
    service: "Wedding Photography",
    image: "https://images-pw.pixieset.com/site/BAJyQr/6wqeRl/001-20210522-c4d5e457-1500.jpg",
  },
  {
    id: 3,
    quote:
      "Great job on our newborn pictures!! She traveled to our location. Super professional and excellent quality. We highly recommend her for family pictures. We loved that she does custom packages and her pricing was way less than what we expected for a on-location custom photo shoot. Loved it!",
    author: "Hernandez Family",
    service: "Newborn & Family Photography",
    image: "https://images-pw.pixieset.com/site/BAJyQr/0PjQvm/18-430f468f-1500.jpg",
  },
];